import React from 'react';

const LOGIN_URL = 'https://beneficial-appreciation-production-5fd3.up.railway.app/login';
const QR_API_URL = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(LOGIN_URL)}`;

export function QRSignagePage() {
  return (
    <>
      <style>{`
        @media print {
          body { margin: 0; padding: 0; }
          .qr-signage-page { padding: 40px 20px !important; }
        }
      `}</style>
      <div className="qr-signage-page" style={styles.page}>
        <div style={styles.container}>
          <h1 style={styles.heading}>KDU Georgia 2026</h1>
          <div style={styles.qrWrapper}>
            <img
              src={QR_API_URL}
              alt="QR code to access My Weekend page"
              width={400}
              height={400}
              style={styles.qrImage}
            />
          </div>
          <p style={styles.instruction}>Scan to access your My Weekend page</p>
          <p style={styles.secondary}>
            Use your ticket number (TKT-XXX) as your username and password
          </p>
        </div>
      </div>
    </>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    padding: '40px 20px',
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  container: {
    textAlign: 'center',
    maxWidth: '600px',
  },
  heading: {
    fontSize: '2.5rem',
    fontWeight: 700,
    color: '#1a6b3c',
    marginBottom: '2rem',
    letterSpacing: '-0.02em',
  },
  qrWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '2rem',
  },
  qrImage: {
    borderRadius: '8px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  },
  instruction: {
    fontSize: '1.75rem',
    fontWeight: 600,
    color: '#0f2d1f',
    marginBottom: '0.75rem',
  },
  secondary: {
    fontSize: '1.25rem',
    color: '#6b7280',
    marginTop: '0.5rem',
  },
};
